import { getGuid } from 'owa-guid';
import { OwaDate } from 'owa-datetime';

export default interface TodoFolder {
    Id: string;
    Name: string;
    IsDefaultFolder: boolean;
    IsSharedFolder: boolean;
    IsOwner: boolean;
    FolderType: ListType;
    SyncStatus: FolderSyncStatus;
    OrderDateTime: OwaDate;
}

export type FolderSyncStatus = 'InProgress' | 'Synced';

export type ListType = 'MyDay' | 'Commitments' | 'FlaggedEmails' | 'Other';

export function createTodoFolder(partialfolder: Partial<TodoFolder>): TodoFolder {
    partialfolder = partialfolder !== null ? partialfolder : {};

    return {
        ...partialfolder,
        Id: partialfolder.Id ? partialfolder.Id : getGuid(),
        Name: partialfolder.Name ? partialfolder.Name : null,
        IsDefaultFolder: partialfolder.IsDefaultFolder ? partialfolder.IsDefaultFolder : false,
        IsSharedFolder: partialfolder.IsSharedFolder ? partialfolder.IsSharedFolder : false,
        IsOwner: partialfolder.IsOwner ? partialfolder.IsOwner : false,
        FolderType: partialfolder.FolderType ? partialfolder.FolderType : 'Other',
        SyncStatus: partialfolder.SyncStatus ? partialfolder.SyncStatus : 'Synced',
        OrderDateTime: partialfolder.OrderDateTime ? partialfolder.OrderDateTime : null,
    };
}
